// extracted by mini-css-extract-plugin
export default {"onboardingContent":"HomePage__onboardingContent___sdaqm"};